var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ElementRef, NgZone } from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { chartConfig } from '../../../../app.constants';
var FollowerGrowthComponent = /** @class */ (function () {
    function FollowerGrowthComponent(userService, _hostElRef, _ngZone) {
        this._hostElRef = _hostElRef;
        this._ngZone = _ngZone;
        this.areaFillColor = {
            linearGradient: {
                x1: 0.5,
                y1: 0.4461,
                x2: 0.5,
                y2: 0.9806
            },
            stops: [
                [0, '#EEF2F57F'],
                [1, "#FFFFFF00"]
            ]
        };
        this.overridenTooltipConfig = {
            useHTML: false,
            padding: 4,
            borderRadius: 6,
            borderWidth: 6,
            borderColor: chartConfig.tooltipBackgroundColor,
            style: {
                color: chartConfig.lineChart.tooltipColor,
                fontFamily: chartConfig.font.light,
                fontSize: '12px'
            }
        };
        this.hasNoData = true;
        this.axisFontFamily = chartConfig.font.semiBold;
        var color = userService.chartColors[1];
        this._seriesConfig = {
            type: 'area',
            color: color,
            name: 'Follower Growth',
            lineWidth: 4,
            marker: { symbol: 'circle', fillColor: color, radius: 4, enabled: true }
        };
        this.placeholderData = [
            __assign({}, this._seriesConfig, { data: [] })
        ];
        this.data = this.placeholderData;
    }
    FollowerGrowthComponent.prototype.ngAfterViewInit = function () {
        this.refreshTooltipInterval();
    };
    FollowerGrowthComponent.prototype.ngOnDestroy = function () {
        this.stopTooltipInterval();
    };
    FollowerGrowthComponent.prototype.stopTooltipInterval = function () {
        if (this._tooltipInterval) {
            clearInterval(this._tooltipInterval);
        }
    };
    FollowerGrowthComponent.prototype.refreshTooltipInterval = function () {
        var _this = this;
        this.stopTooltipInterval();
        this._ngZone.runOutsideAngular(function () {
            _this._tooltipInterval = setInterval(function () {
                var hostEl = _this._hostElRef && _this._hostElRef.nativeElement;
                if (hostEl) {
                    var textEl = hostEl.querySelector('.highcharts-tooltip > text');
                    if (textEl) {
                        textEl.setAttribute('y', 14);
                        clearInterval(_this._tooltipInterval);
                    }
                }
            }, 10);
        });
    };
    FollowerGrowthComponent.prototype.ngOnChanges = function (changes) {
        if (changes.followerGrowths) {
            var value = changes.followerGrowths.currentValue;
            if (!Array.isArray(value) || value.length === 0) {
                this.hasNoData = true;
                this.stopTooltipInterval();
                return;
            }
            this.yAxisMax = Math.max.apply(Math, value.map(function (x) { return x.follower; })) * 1.5;
            this.data = this.convertToChartData(value);
            this.hasNoData = false;
            this.refreshTooltipInterval();
        }
    };
    FollowerGrowthComponent.prototype.convertToChartData = function (followerGrowths) {
        var _this = this;
        var data = followerGrowths.map(function (x) {
            return [_this.convertToDateNumber(x.time), x.follower];
        });
        return [__assign({}, this._seriesConfig, { data: data })];
    };
    /**
    * @param {number} monthString: MM-YYYY
    */
    FollowerGrowthComponent.prototype.convertToDateNumber = function (monthString) {
        var parts = monthString.split('-');
        var year = Number.parseInt(parts[1], 10);
        var month = Number.parseInt(parts[0], 10) - 1;
        var date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        return date.getTime();
    };
    return FollowerGrowthComponent;
}());
export { FollowerGrowthComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/follower-growth/follower-growth.component.ts.pre-build-optimizer.js